import { StatisticsKind } from '..';

export const getStatisticsKindFilterOptions = (): any[] => {
  return [
    StatisticsKind.SOIL_TEMPERATURE,
    StatisticsKind.YIELD_APPLIED_DOSE,
    StatisticsKind.YIELD_SOIL_PARAMETER,
    StatisticsKind.YIELD_STEM_NUMBER,
    StatisticsKind.YIELD_ZONE_STRENGTH
  ].map((status) => ({
    name: `statistics.kind.${status}`,
    value: status
  }));
};
